import React, { Suspense, lazy } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Footer from './components/Footer';
import Newsletter from './components/Newsletter';
import EmailPopup from './components/EmailPopup';

import About from './components/About';
import Services from './components/Services';
import News from './components/News';
import Give from './components/Give';
import Contact from './components/Contact';
import LiveStream from './components/LiveStream';
import SermonArchive from './components/SermonArchive';
import Sermons from './components/Sermons';

const ArticlePage = lazy(() => import('./components/ArticlePage'));
const NotFound = lazy(() => import('./components/NotFound'));
const StatementOfFaith = lazy(() => import('./components/StatementOfFaith'));
const Salvation = lazy(() => import('./components/Salvation'));
const Tracts = lazy(() => import('./components/Tracts'));
const CatholicsTract = lazy(() => import('./components/Tracts/Catholics'));
const AdminDashboard = lazy(() => import('./components/Admin/Dashboard'));
const PrayerRequest = lazy(() => import('./components/Pages/PrayerRequest'));
const ShareTestimony = lazy(() => import('./components/Pages/ShareTestimony'));

const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-600"></div>
  </div>
);

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <LiveStream />
      <SermonArchive />
      <News />
      <Newsletter />
      <Give />
      <Contact />
    </>
  );
}

function AppLayout() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');

  return (
    <div className="min-h-screen relative">
      {!isAdmin && <Navbar />}
      <ScrollToTop />
      {!isAdmin && <EmailPopup />}
      <div className="relative z-10">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:slug" element={<ArticlePage />} />
            <Route path="/statement-of-faith" element={<StatementOfFaith />} />
            <Route path="/salvation" element={<Salvation />} />
            <Route path="/tracts" element={<Tracts />} />
            <Route path="/tracts/catholics" element={<CatholicsTract />} />
            <Route path="/prayer-request" element={<PrayerRequest />} />
            <Route path="/share-testimony" element={<ShareTestimony />} />
            <Route path="/sermons" element={<Sermons />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Suspense>
        {!isAdmin && <Footer />}
      </div>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <AppLayout />
    </ErrorBoundary>
  );
}
